<template>
  <TeamMembersPanel
    v-model:selected-users="selected_users"
    v-model:deselected-users="deselected_users"
    v-model:excluded-users="excluded_users"
    v-model:disabled-users="disabled_users"
    :title="$t('Share') + ` ${page.name} ` + $t('Page as a Template')"
    @submit="sharePage"
    @cancel="$emit('cancel')" />
</template>

<script>
import TeamMembersPanel from "../shared/TeamMembersPanel.vue"
export default {
  components: {
    TeamMembersPanel
  },
  inject: ["clonePageToTeamMember"],
  props: {
    page: {
      type: Object,
      required: true
    }
  },
  emits: ["cancel", "submitted", "done"],
  data() {
    return {
      excluded_users: [this.$store.state.auth.user],
      initial_cloned_with_users: [],
      disabled_users: [],
      selected_users: [],
      deselected_users: []
    }
  },

  created() {
    this.initial_cloned_with_users = this.page.cloned_with || []
    this.selected_users = this.$store.state.data.users.filter(
      (u) => this.initial_cloned_with_users.filter((uid) => uid == u.id).length != 0
    )
    this.disabled_users = this.$store.state.data.users.filter(
      (u) => this.initial_cloned_with_users.filter((uid) => uid == u.id).length != 0
    )
  },

  methods: {
    sharePage() {
      // remove initial_cloned_with_users from selected_users
      this.selected_users = this.selected_users
        .filter((u) => this.initial_cloned_with_users.filter((uu) => uu.id == u.id).length == 0)
        .map((u) => u.id)
      this.clonePageToTeamMember({ page: this.page, users: this.selected_users })
      this.$emit("done")
    }
  }
}
</script>
